import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

const server = 'https://infinite-dusk-89390.herokuapp.com';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      DECA Games.
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default ({showItem, callback, id, name, bag, slot, description}) => {
  const [version, setVersion] = useState(null);

  useEffect(() => {
    axios.get(`${server}/getVersion`).then((res) => setVersion(res.data));
  }, []);
  return (
    <div>
      <Typography align="center" gutterBottom>
        {version
          ? `Based on: ROTMG v. ${version.version} (last updated ${version.lastUpdate})`
          : ''}
      </Typography>
      <Copyright />
      <Typography variant="body2" color="textSecondary" align="center">
        <Link color="inherit" href="/">
          ROTMG DROPS Tracker
        </Link>
      </Typography>
    </div>
  );
};
